import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import Input from 'components/Input'
import Button from 'components/Button'
import useAuth from 'customHook/useAuth'
import { Container, ContentContainer } from './styles'
import Logo from 'assets/Logo.png'

const Login = ({ redirectPath }) => {
  
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const { userLogin, loginLoading } = useAuth();
  
  const login = () => {
    if(loginLoading) return
    if (email.length > 0) {
      if(password.length > 6) {     
        userLogin(email, password, setPasswordError)
      } else {
        setPasswordError(true)
      }
    } else {
      setEmailError(true)
    }
  }

  const forgetPassword = () => {
    history.push('/forgetPassword')
  }

  return (
    <Container>
      <Helmet>
        <title>Login - Rook Hotel PMS</title>
        <meta name="description" content="Login - Rook Hotel PMS" />
      </Helmet>
      <ContentContainer>
        <img src={Logo} alt="Logo" />
        <div className='brand'>
          <span className='rook'>ROOK </span>
          <span className='hotel'>HOTEL</span>
        </div>
        <Input
          error={emailError}
          errorMessage={'Please enter a valid email address.'}
          placeholder={'Email Address'}
          onChange={(e) => setEmail(e.target.value)}
          additionalstyle={`
            width: 100%;
            margin-top: 24px;
            input {
              height: 51px;
              font-size: 14px;
              font-weight: 400;
            }
          `}
        />
        <Input
          error={passwordError}
          errorMessage={password.length? 'Incorrect password. Please try again.': 'This field is required.'}
          placeholder={'Password'}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          additionalstyle={`
            width: 100%;
            margin-top: 24px;
            input {
              height: 51px;
              font-size: 14px;
              font-weight: 400;
            }
          `}
        />
        <div
          className='highlight'
          onClick={forgetPassword}
        >
          Can’t remember your password?
        </div>
        <Button
          mainPage
          onClick={login}
          data-loading={loginLoading}
          additionalstyle={`
            width: 89px;
            height: 51px;
            margin-top: 24px;
          `}
        >
        {loginLoading? null: 'Log In'}
        </Button>
      </ContentContainer>
    </Container>
  );
};

export default Login;
